<template>
  <div :class="attrs.class">
    <div class="label">{{ trans("live.catalog.lot_card.current_bid") }}</div>
    <div class="value">{{ format_currency(props.currentBidProp) }}</div>
  </div>
</template>

<script lang="ts" setup>
  import { defineProps, useAttrs } from "vue";
  import { format_currency } from "@/utils/currencies";
  import { trans } from "@/utils/trans";

  const attrs = useAttrs();

  const props = defineProps<{
    currentBidProp: number;
  }>();
</script>
